import { render, staticRenderFns } from "./TaxDataEdit.vue?vue&type=template&id=238e9ece&scoped=true&"
import script from "./TaxDataEdit.vue?vue&type=script&lang=js&"
export * from "./TaxDataEdit.vue?vue&type=script&lang=js&"
import style0 from "./TaxDataEdit.vue?vue&type=style&index=0&id=238e9ece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238e9ece",
  null
  
)

export default component.exports